import React, { useState, useEffect } from "react"
import starIcon from "../../assets/star.svg"
import starOutlineIcon from "../../assets/starOutline.svg" // Import the starOutline.svg
import "../styles/Rating.css"

function Rating({ rating, onSelect }) {
  const [ratingState, setRatingState] = useState(
    rating || Math.floor(Math.random() * 5) + 1
  )
  const [stars, setStars] = useState([])

  useEffect(() => {
    const stars = generateStars(ratingState)
    setStars(stars)
  }, [ratingState])

  const onClick = (starIndex) => {
    if (!onSelect) return
    setRatingState(starIndex)
    if (typeof onSelect === "function") {
      onSelect(starIndex)
    }
  }

  const generateStars = (rating) => {
    const stars = []

    for (let i = 1; i <= 5; i++) {
      const rand = Math.floor(Math.random() * 10000000)
      const starClasses = [
        "star",
        i <= rating ? "gold" : "",
        onSelect ? "clickable" : "",
      ]
      stars.push(
        <img
          key={i + rand}
          src={i <= rating ? starIcon : starOutlineIcon} // Use starOutlineIcon for outline
          alt="Star"
          onClick={() => onClick(i)}
          className={starClasses.join(" ")}
        />
      )
    }
    return stars
  }

  return <div className="stars-container">{stars}</div>
}

export default Rating
